<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn text v-bind="attrs" v-on="on">
				<v-icon class="mr-1 white--text">
					mdi-account-circle
				</v-icon>

				<span class="user-name">
					<!-- Slot UserName -->
					<slot name="username"></slot>
				</span>
				<v-icon class="ml-1 white--text">
					mdi-chevron-down
				</v-icon>
			</v-btn>
		</template>
		<v-list>
			<!-- Slot Items -->
			<slot name="items"></slot>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	data() {
		return {};
	},

	methods: {},

	computed: {},
};
</script>

<style lang="css" scoped>
.user-name {
	color: #fff;
	font-weight: 400;
	width: 150px;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px !important;
	letter-spacing: initial;
}
</style>
